import baseService from "../services/BaseService";
export const deleteOrderOfferDetail = async (id, data) =>
  baseService.post(`order-offer-details/cancel/${id}`, data);
export const recoverOrderOfferDetail = async (id, data) =>
  baseService.post(`order-offer-details/uncancel/${id}`, data);
export const getOrderDetailsById = async (id) =>
  baseService.get(`orderdetails/${id}`);
export const confirmOrderService = async (id, data) =>
  baseService.post(`order/confirm/${id}`, data);
